import React, { useEffect, useState, useMemo } from "react";
import Fieldset from "../../../../Components/Common/Fieldset/Fieldset";
import {
  Button,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import "./productModal.scss";
import { formState } from "../../../AGMember/Json/AgMemberJson";
import { add } from "@dnd-kit/utilities";

function ProductModal({ show, onHide, selectedProductEntityId }) {
  const productData = useSelector(
    (state) => state.order.selectedOrders.selectedProductData
  );
  const productAttributeData = useSelector(
    (state) => state.order.productAttributeData
  );
  const selectedProductAttributeList = productAttributeData?.find((val) => val.entityid === selectedProductEntityId)?.product_attributes_list;

  const selectedProductDataVal = productData?.find(
    (val) => val.entityid === selectedProductEntityId
  );


  const selectedProductAddOn = productAttributeData?.find((val) => val.entityid === selectedProductEntityId)?.product_addon_list
 function formatToIndianShort(number) {
  if (number === null || number === undefined || isNaN(number)) return number;
  const num = Number(number);
  if (num < 100000) {
    return num.toString();
  }
  if (num < 10000000) {
    return (num / 100000).toFixed(2).replace(/\.00$/, "")+ " L";
  }
  return (num / 10000000).toFixed(2).replace(/\.00$/, "") + " Cr";
}
  
  const attributes = useMemo(() => {
    const attrs = selectedProductDataVal?.product_info?.Attributes;
    if (!Array.isArray(attrs)) return [];
    return attrs.map((attr, i) => ({
      ...attr,
      format_type:
      selectedProductAttributeList?.[i]?.format_type ?? attr.format_type
    }));
  }, [selectedProductDataVal, selectedProductAttributeList]);
  
  

  const addOns = useMemo(() => {
        const addOnsArr = selectedProductDataVal?.product_info?.Add_Ons;
        if(!Array.isArray(addOnsArr)) return [];

        const updatedAddOnsArr = addOnsArr.map((addOn, i) => {
             return {
                 ...addOn,
                 format_type: selectedProductAddOn?.[i]?.format_type ?? addOn.format_type
             }
        })


        return updatedAddOnsArr;
  }, [selectedProductDataVal, selectedProductAddOn])

  const hasAttributes =
    selectedProductDataVal?.product_info?.Attributes?.length > 0;
  const hasAddOns = selectedProductDataVal?.product_info?.Add_Ons?.length > 0;
 
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={onHide}
    >
      <Form className="tablelist-form">
        <Modal.Header className="p-3 bg-info-subtle" closeButton>
          Product Info
        </Modal.Header>
        <Modal.Body className="modal-body">
          <Row className="g-3">
            {hasAttributes && (
              <Col lg={12}>
                <Fieldset title={"Attributes"} />

                <>
                  <div className="attributes-container">
                    <Row>
                      {selectedProductDataVal?.product_info?.Attributes.map(
                        (i, index) => (
                          <Col xs={6}>
                            <div key={index} className="attributes">
                              <Form.Label htmlFor="inputPassword5">
                                {i.label}
                              </Form.Label>
                              <Form.Control
                                disabled
                                type="text"
                                value={i.value}
                              />
                            </div>
                          </Col>
                        )
                      )}
                    </Row>
                  </div>
                </>
              </Col>
            )}
            {hasAddOns && (
              <Col lg={12}>
                <Fieldset title={"Add ons"} />

                <>
                  <div className="attributes-container">
                    <Row>
                      {selectedProductDataVal?.product_info?.Add_Ons.map(
                        (i, index) => (
                          <Col xs={6}>
                            <div key={index} className="attributes">
                              <Form.Label htmlFor="inputPassword5">
                                {i.label}
                              </Form.Label>
                              <Form.Control
                                disabled
                                value={i.value}
                                htmlFor="inputPassword5"
                              />
                            </div>
                          </Col>
                        )
                      )}
                    </Row>
                  </div>
                </>
              </Col>
            )}
          </Row>
        </Modal.Body>
      </Form>
    </Modal>
  );
}

export default ProductModal;
